"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { ArrowRight, Calendar } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Contact() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const eventCards = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/medical_consultation_room.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/medical_consultation_room.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/medical_consultation_room.webp-wvc-sizes",
    alt: "Medical consultation room",
    date: "PRENOTAZIONI",
    label: "Visite Specialistiche",
    rotate: "-rotate-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/fertility_lab_analysis.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/fertility_lab_analysis.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/fertility_lab_analysis.webp-wvc-sizes",
    alt: "Fertility laboratory analysis",
    date: "FISIOPATOLOGIA",
    label: "Riproduzione Umana",
    rotate: "rotate-2"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/forensic_medical_report.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/forensic_medical_report.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/forensic_medical_report.png-wvc-sizes",
    alt: "Forensic medical report documentation",
    date: "CONSULENZA",
    label: "Ginecologia Forense",
    rotate: "-rotate-1"
  }];
  const marqueeItems = ["OSTETRICIA", "GINECOLOGIA", "RIPRODUZIONE", "CONSULENZA", "FORENSE", "PREVENZIONE"];
  return <section data-section-id="551" id="contatta-lo-studio" className="dark bg-background text-foreground relative overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-12 min-h-[640px]">
        {}
        <div ref={contentRef} className={`lg:col-span-8 bg-background px-6 sm:px-10 lg:px-16 xl:px-24 py-16 lg:py-24 flex flex-col justify-center transition-all duration-700 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="max-w-3xl">
            <Badge variant="default" className="bg-primary text-primary-foreground font-mono text-[0.7rem] tracking-widest uppercase px-3 py-1 mb-8">
              Dott. Mirko Colloca
            </Badge>

            <h1 className="font-default font-semibold tracking-tight text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.95] text-foreground mb-8">
              Eccellenza
              <br />
              nella cura —
              <br />
              <span className="italic font-serif font-normal text-muted-foreground">
                con competenza.
              </span>
            </h1>

            <p className="font-default text-lg sm:text-xl text-muted-foreground max-w-xl leading-relaxed mb-10">Medico Chirurgo specialista in Ginecologia e Ostetricia. Offro consulenze esperte in Ginecologia e Ostetricia Fisiopatologia della Riproduzione Umana e Ostetricia e Ginecologia Forense con approccio clinico rigoroso.</p>

            <div className="flex flex-wrap items-center gap-4">
              <Link to="/ContactsPage">
                <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg px-6 h-12 font-medium text-base">
                  Prenota visita
                  <ArrowRight className="ml-1" />
                </Button>
              </Link>
              <Link to="/ProfilePage" className="font-default font-medium text-foreground hover:text-primary transition-colors underline underline-offset-4 decoration-border hover:decoration-primary px-2">
                Il mio profilo
              </Link>
            </div>

            <div className="mt-12 flex items-center gap-3 text-sm text-muted-foreground font-mono">
              <SafeHydrate><Calendar className="size-4" /></SafeHydrate>
              <span className="tracking-wider">DISPONIBILE PER CONSULENZE</span>
            </div>
          </div>
        </div>

        {}
        <div ref={cardsRef} className={`lg:col-span-4 bg-secondary/60 px-6 sm:px-10 lg:px-8 xl:px-12 py-16 lg:py-24 flex flex-col justify-center gap-6 relative transition-all duration-700 ease-out delay-150 ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {eventCards.map((card, i) => <div key={i} data-index={i} className={`relative ${card.rotate} hover:rotate-0 transition-transform duration-500 ease-out`} style={{
          marginLeft: i === 1 ? "1.5rem" : i === 2 ? "0.5rem" : "0",
          marginRight: i === 0 ? "1rem" : i === 2 ? "2rem" : "0"
        }}>
              <div className="relative overflow-hidden rounded-2xl bg-card shadow-xl ring-1 ring-border/40">
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={card.src} data-wvc-srcset={card.srcset} data-wvc-sizes={card.sizes} alt={card.alt} loading="lazy" decoding="async" className="w-full h-full object-cover" />
                </div>
                <div className="absolute top-3 left-3">
                  <span className="inline-block bg-background/90 backdrop-blur-sm text-foreground font-mono text-[0.65rem] tracking-widest uppercase px-2.5 py-1 rounded-md shadow-sm">
                    {card.date}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background/95 via-background/60 to-transparent px-4 py-3 pt-8">
                  <p className="font-default font-medium text-sm text-foreground">
                    {card.label}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>

      {}
      <div className="border-t border-border bg-background py-6 lg:py-8 overflow-hidden relative">
        <div className="flex whitespace-nowrap animate-[marquee_40s_linear_infinite]">
          {[...marqueeItems, ...marqueeItems, ...marqueeItems].map((item, i) => <div key={i} data-index={i} className="flex items-center shrink-0">
              <span className="font-default font-semibold tracking-tight text-4xl sm:text-5xl lg:text-6xl text-foreground px-8">
                {item}
              </span>
              <span className="text-primary text-4xl sm:text-5xl lg:text-6xl">
                ·
              </span>
            </div>)}
        </div>
        <style>{`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-33.333%); }
          }
        `}</style>
      </div>
    </section>;
}